<template>
	<svg
		class="arrow-icon"
		:class="direction"
		width="9px"
		height="9px"
		viewBox="0 0 7 7"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
	>
		<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g transform="translate(-16.000000, -29.000000)" fill="#ACAEB2">
				<g transform="translate(16.000000, 29.000000)">
					<g transform="translate(-0.000000, 0.000000)">
						<g
							transform="translate(3.500000, 3.500000) rotate(-360.000000) translate(-3.500000, -3.500000) translate(-0.000000, 0.000000)"
						>
							<path
								d="M6.125,0.875 C6.608875,0.875 7,1.267 7,1.75 C7,2.11225 6.8355,2.331875 6.685,2.5445 C6.685,2.5445 4.395125,5.58425 4.118625,5.868625 C3.948875,6.043625 3.724,6.125 3.5,6.125 C3.276,6.125 3.051125,6.043625 2.881375,5.868625 C2.604875,5.58425 0.315,2.5445 0.315,2.5445 C0.1645,2.331875 0,2.11225 0,1.75 C0,1.267 0.391125,0.875 0.875,0.875 L6.125,0.875 Z"
								transform="translate(3.500000, 3.500000) rotate(-360.000000) translate(-3.500000, -3.500000) "
							></path>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export const directions = {
	UP: 'up',
	DOWN: 'down',
	LEFT: 'left',
	RIGHT: 'right',
}
export default {
	name: 'ArrowIcon',
	props: {
		direction: {
			type: String,
			default: directions.DOWN,
			validator: (val) => Object.values(directions).includes(val),
		},
	},
}
</script>

<style lang="scss" scoped>
.arrow-icon {
	transition: transform 0.2s ease-in-out;
	&.up {
		transform: rotate(180deg);
	}
	&.left {
		transform: rotate(90deg);
	}
	&.right {
		transform: rotate(-90deg);
	}
}
</style>
